export class ContasReceberGetAllRequest {
    pesquisa: string | null;
    refinamento: number | null;
    dataInicio: string | null;
    dataFim: string | null;
    idStatus: number | null;
    idCategoria: number | null;
    idFormaRecebimento: number | null;
    tags: number[] | null;
    somenteVencidos: boolean | null;
}
